import {immerable, produce, WritableDraft} from "immer"
import { Note } from "./Note"
import { HexMapModifier } from "./HexMapModifier"
import { HexMap } from "./HexMap"
export interface DisplayConfigParams{
    keyRadius:number, 
    noteRadiusToKeyRadius?:number,
    noteFontSize?:number,
    petalLabelRadius?:number
}
export default class DisplayConfig{
    noteRadiusToKeyRadius:number
    noteFontSize:number
    keyRadius:number
    petalLabelRadius:number
    static default_noteRadiusToKeyRadius:number = .3
    constructor(params:DisplayConfigParams){
        this.noteRadiusToKeyRadius = (params.noteRadiusToKeyRadius) ? params.noteRadiusToKeyRadius : DisplayConfig.default_noteRadiusToKeyRadius
        this.noteFontSize = (params.noteFontSize) ? params.noteFontSize : this.getNoteFontSize()
        this.keyRadius = params.keyRadius
        this.petalLabelRadius = (params.petalLabelRadius) ? params.petalLabelRadius : this.keyRadius/2.5
    }
    getKeyFontSize(){
        let fontSize:number = (this.keyRadius * .7)
        const minimumSize:number = 15
        const maximumSize:number = 80
        if(fontSize < minimumSize) fontSize = minimumSize
        if(fontSize > maximumSize) fontSize = maximumSize
        return fontSize
    }
 
    getNoteFontSize(){
        const circleDiameter:number = this.getCircleRadius() * 2
        return circleDiameter * .6
    }
    getCircleRadius(){
        return this.keyRadius * this.noteRadiusToKeyRadius
    }
    getPositionType(note:Note){
        if(note.keys.length === 0){
            return 0
        }
        const firstPosition:number = note.keys[0].position
        if(firstPosition === 6) return(7)
        return ((firstPosition + 1) % 2)
    }
    static default_onKeyClick(setter:Function, keyIndex:number){
        setter(produce((draft:WritableDraft<HexMap>)=>{
            const mod:HexMapModifier = new HexMapModifier(draft)
            mod.keys_advanceSelectedState([keyIndex])
        }))
    }
}